var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "22", viewBox: "0 0 24 22", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { id: "navbar-likes-likes-icon-Symbols", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "g",
        { id: "navbar-likes-likes-icon-Icon/Like/24", transform: "translate(0 -2)", fill: "#1A1A1A", fillRule: "nonzero" },
        React.createElement("path", { d: "M17.437 2.162C21.07 2.162 24 5.244 24 9.026c0 2.91-2.097 6.162-5.601 9.607a49.2 49.2 0 0 1-3.888 3.417l-.727.568c-.38.291-.72.543-1.007.75l-.349.247a.75.75 0 0 1-.85.004l-.5-.353-.62-.456-.676-.516a49.08 49.08 0 0 1-3.927-3.38c-2.356-2.267-4.129-4.5-5.083-6.634C.267 11.152 0 10.065 0 9.026c0-3.782 2.93-6.864 6.563-6.864 2.14 0 4.081 1.08 5.29 2.8l.147.22.147-.22c1.209-1.72 3.15-2.8 5.29-2.8zm0 1.5c-2.113 0-3.987 1.387-4.731 3.454-.238.662-1.174.662-1.412 0-.744-2.067-2.618-3.454-4.731-3.454-2.787 0-5.063 2.394-5.063 5.364 0 .81.217 1.694.641 2.642.86 1.923 2.524 4.02 4.754 6.165a47.605 47.605 0 0 0 3.807 3.276l.529.405.251.188.516.378.392-.289c.14-.104.287-.215.443-.334l.746-.582a47.725 47.725 0 0 0 3.768-3.312c3.237-3.181 5.153-6.154 5.153-8.537 0-2.97-2.276-5.364-5.063-5.364zM7.252 5.404a.75.75 0 0 1 0 1.5 2.543 2.543 0 0 0-2.543 2.543.75.75 0 0 1-1.5 0 4.043 4.043 0 0 1 4.043-4.043z", id: "navbar-likes-likes-icon-Combined-Shape" })
      )
    )
  );
});


// WEBPACK FOOTER //
// ./src/routers/Desktop/NavBar/components/icons/Likes.svg